import { any, number, object, string } from 'prop-types';

// import { initCMS } from 'utils/cms';
import Layout from 'components/layout';
import MyAccountLayout from 'components/layout/myaccount';

import { KboixTipsForm } from 'components/nnormal-world/tipsForm';
import { IS_CAMPER } from 'utils/constants/system';
import { initCMS } from 'utils/cms';
import { useKboixUser } from 'actions/nnormal-world';
import { useEffect } from 'react';
import { useLink } from 'hooks';
import styles from './style.module.css';

/** @type import('next/types').GetServerSideProps */
export async function getServerSideProps(context) {
  const { locale } = context;
  if (IS_CAMPER) {
    return {
      redirect: {
        destination: `/${locale}/myaccount`,
        permanent: false,
      },
    };
  }
  const { defaultProps } = await initCMS({ context, locale });

  return {
    props: {
      pageName: 'nnormal_world_tips_register',
      defaultProps,
    },
  };
}

export default function KboixWorldRacesRoute({ defaultProps, pageName }) {
  const { data, isLoading } = useKboixUser();
  const to = useLink();

  useEffect(() => {
    if (data?.isCompletedForm === true) {
      window.location.assign(to('/myaccount/nnormal-world/tips'));
    }
  }, [data?.isCompletedForm]);

  return (
    <Layout {...defaultProps} breadcrumbs={false} pageName={pageName}>
      <MyAccountLayout withCategoriesLayout={false}>
        <div className={styles.layout} data-loading={isLoading}>
          <KboixTipsForm />
        </div>
      </MyAccountLayout>
    </Layout>
  );
}

KboixWorldRacesRoute.propTypes = {
  footerProps: any,
  tnmProps: any,
  pageName: string,
  gtmProps: object,
  ribbon: any,
  reference: string,
  customerReference: string,
  subtotal: number,
  locale: string,
};

KboixWorldRacesRoute.defaultProps = {
  pageName: 'Kboix World Tips Register',
};

KboixWorldRacesRoute.i18nPage = 'KboixWorldTipsRegister';
